module.exports = __webpack_public_path__ + "assets/images/Caixa-danilo_d8ec40eeecdb1c239ba4d5e105d7e5da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-two/Caixa-danilo.png
// module id = 202
// module chunks = 0